import { render, staticRenderFns } from "./ReelCard.vue?vue&type=template&id=b5e0cbbc&scoped=true"
import script from "./ReelCard.vue?vue&type=script&lang=js"
export * from "./ReelCard.vue?vue&type=script&lang=js"
import style0 from "./ReelCard.vue?vue&type=style&index=0&id=b5e0cbbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e0cbbc",
  null
  
)

export default component.exports